/* ═══════════════════════════════════════════════════════════
   KALÉN & ROSE — HOMEPAGE INTERACTIONS
   - Hero carousel
   - Scroll reveal
   - 15% off popup
   - Skincare quiz w/ Klaviyo identify + Shopify customer signup
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── HERO CAROUSEL ── */
  const slides = document.querySelectorAll('.hero-slide');
  const dots   = document.querySelectorAll('.hero-dot');
  let current = 0;

  function goSlide(n) {
    if (!slides.length) return;
    slides[current].classList.remove('active');
    if (dots[current]) dots[current].classList.remove('active');
    current = n;
    slides[current].classList.add('active');
    if (dots[current]) dots[current].classList.add('active');
  }
  dots.forEach(d => d.addEventListener('click', () => goSlide(+d.dataset.slide)));
  if (slides.length) setInterval(() => goSlide((current + 1) % slides.length), 4500);

  /* ── SCROLL REVEAL ── */
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  /* ── KLAVIYO HELPERS ── */
  function klaviyoIdentify(email, props) {
    if (!email || !email.includes('@')) return false;
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', Object.assign({
        '$email':  email,
        '$source': 'kalenandrose.com'
      }, props || {})]);
      return true;
    } catch (e) { console.warn('Klaviyo identify failed', e); return false; }
  }
  function klaviyoTrack(eventName, props) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', eventName, props || {}]);
    } catch (e) { console.warn('Klaviyo track failed', e); }
  }
  // Also subscribe to Shopify customer list (dual-write for redundancy)
  function shopifySubscribe(email, tags) {
    return fetch('/contact#contact_form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form_type': 'customer',
        'utf8': '✓',
        'contact[email]': email,
        'contact[tags]': tags || 'newsletter'
      })
    }).catch(() => {});
  }

  window.krKlaviyoIdentify = klaviyoIdentify;
  window.krKlaviyoTrack = klaviyoTrack;
  window.krShopifySubscribe = shopifySubscribe;

  /* ── 15% OFF POPUP ── */
  window.krShowPopup = function () {
    const p = document.getElementById('popup');
    if (p && !sessionStorage.getItem('popupDismissed')) p.classList.add('show');
  };
  window.krClosePopup = function () {
    const p = document.getElementById('popup');
    if (p) p.classList.remove('show');
    sessionStorage.setItem('popupDismissed', '1');
  };
  const popupEl = document.getElementById('popup');
  if (popupEl) {
    popupEl.addEventListener('click', e => { if (e.target === popupEl) window.krClosePopup(); });
    setTimeout(window.krShowPopup, 4000);
  }
  window.submitPopup = function (e) {
    e.preventDefault();
    const email = document.getElementById('popupEmail').value;
    klaviyoIdentify(email, { 'Lead Source': 'Welcome Popup' });
    klaviyoTrack('Subscribed via Popup', { '$email': email });
    shopifySubscribe(email, 'newsletter,popup-15off');
    window.krClosePopup();
  };

  /* ── FOOTER EMAIL ── */
  const footerForm = document.getElementById('footerEmailForm');
  if (footerForm) {
    footerForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = document.getElementById('footerEmail').value;
      klaviyoIdentify(email, { 'Lead Source': 'Footer Email Signup' });
      klaviyoTrack('Subscribed via Footer', { '$email': email });
      shopifySubscribe(email, 'newsletter,footer-15off');
      document.getElementById('footerEmail').value = '';
      const msg = document.getElementById('footerEmailMsg');
      if (msg) msg.style.display = 'block';
    });
  }

  /* ── SKINCARE QUIZ ── */
  const quizAnswers = {};
  let currentQ = 0;

  window.krOpenQuiz = function () {
    const m = document.getElementById('quizModal');
    if (m) { m.classList.add('show'); document.body.style.overflow = 'hidden'; }
    klaviyoTrack('Opened Skin Quiz', {});
  };
  window.krCloseQuiz = function () {
    const m = document.getElementById('quizModal');
    if (m) { m.classList.remove('show'); document.body.style.overflow = ''; }
  };
  const quizEl = document.getElementById('quizModal');
  if (quizEl) quizEl.addEventListener('click', e => { if (e.target === quizEl) window.krCloseQuiz(); });

  window.krPick = function (el, key, val) {
    el.parentElement.querySelectorAll('.quiz-opt').forEach(o => o.classList.remove('selected'));
    el.classList.add('selected');
    quizAnswers[key] = val;
    const btn = document.getElementById('next' + currentQ);
    if (btn) btn.disabled = false;
  };
  window.krNextQ = function (n) {
    document.getElementById('qStep' + currentQ).classList.remove('active');
    currentQ = n;
    document.getElementById('qStep' + n).classList.add('active');
    const prog = document.getElementById('qProgress');
    if (prog) prog.style.display = 'flex';
    document.querySelectorAll('.quiz-prog').forEach(p => {
      p.classList.toggle('done', +p.dataset.step <= n);
    });
  };
  window.krPrevQ = function (n) {
    document.getElementById('qStep' + currentQ).classList.remove('active');
    currentQ = n;
    document.getElementById('qStep' + n).classList.add('active');
    document.querySelectorAll('.quiz-prog').forEach(p => {
      p.classList.toggle('done', +p.dataset.step <= n);
    });
  };

  window.krShowResult = function () {
    document.getElementById('qStep' + currentQ).classList.remove('active');
    document.getElementById('qResult').classList.add('active');
    document.querySelectorAll('.quiz-prog').forEach(p => p.classList.add('done'));

    const catalog = window.krProducts || {};
    const map = window.krQuizMap || {};
    const rec = map[quizAnswers.concern] || map.antiaging || map.eczema || {};
    const primary = catalog[rec.primary] || {};

    document.getElementById('qrTitle').textContent = rec.headline || '';
    document.getElementById('qrSub').textContent   = rec.sub || '';
    document.getElementById('qrImg').src           = primary.img || '';
    document.getElementById('qrImg').alt           = primary.name || '';
    document.getElementById('qrName').textContent  = primary.name || '';
    document.getElementById('qrTag').textContent   = primary.tag || '';
    document.getElementById('qrPrice').textContent = primary.price || '';
    document.getElementById('qrLink').href         = primary.link || '#';

    // Render ritual add-ons
    const addonIds = rec.addons || [];
    const ritual = document.getElementById('qrRitual');
    const ritualCards = document.getElementById('qrRitualCards');
    if (ritual && ritualCards) {
      if (addonIds.length) {
        ritualCards.innerHTML = addonIds.map(function (id) {
          var p = catalog[id]; if (!p) return '';
          return '<div class="quiz-addon">' +
            '<img src="' + (p.img || '') + '" alt="' + (p.name || '').replace(/"/g, '&quot;') + '">' +
            '<div><div class="quiz-addon-name">' + (p.name || '') + '</div>' +
            '<div class="quiz-addon-price">' + (p.price || '') + '</div>' +
            '<a class="quiz-addon-btn" href="' + (p.link || '#') + '">Add to ritual →</a></div></div>';
        }).join('');
        ritual.style.display = '';
      } else {
        ritualCards.innerHTML = '';
        ritual.style.display = 'none';
      }
    }

    klaviyoTrack('Completed Skin Quiz', {
      'Concern': quizAnswers.concern,
      'Recommended Product': primary.name,
      'Product URL': primary.link,
      'Ritual Add-ons': addonIds.map(function (id) { return (catalog[id] || {}).name; }).filter(Boolean).join(', ')
    });
  };

  window.krClaimResult = function (e) {
    e.preventDefault();
    const email = document.getElementById('qrEmail').value;
    if (!email || !email.includes('@')) return;

    const catalog = window.krProducts || {};
    const map = window.krQuizMap || {};
    const rec = map[quizAnswers.concern] || map.antiaging || {};
    const m = catalog[rec.primary] || {};
    klaviyoIdentify(email, {
      'Skin Concern': quizAnswers.concern,
      'Skin Type':    quizAnswers.type,
      'Age Range':    quizAnswers.age,
      'Skin Goal':    quizAnswers.goal,
      'Lifestyle':    quizAnswers.lifestyle,
      'Quiz Recommended Product': m.name,
      'Lead Source':  'Skincare Quiz'
    });
    klaviyoTrack('Quiz Email Captured', { '$email': email, 'Recommended': m.name });
    shopifySubscribe(email, 'newsletter,skincare-quiz,concern-' + (quizAnswers.concern || 'unknown'));

    const btn = e.target;
    btn.textContent = '✓ Sent!';
    btn.style.background = 'var(--sage, #8FA68A)';
    setTimeout(() => { if (m.link) window.open(m.link, '_blank'); }, 700);
  };

  // Bundle video — apply slow-motion playback rate from data-rate
  document.querySelectorAll('.bundle-media').forEach(function (v) {
    var rate = parseFloat(v.getAttribute('data-rate')) || 0.5;
    var apply = function () { try { v.playbackRate = rate; } catch (e) {} };
    apply();
    v.addEventListener('loadedmetadata', apply);
    v.addEventListener('play', apply);
  });

  window.krRetakeQuiz = function () {
    document.getElementById('qResult').classList.remove('active');
    currentQ = 0;
    document.getElementById('qStep0').classList.add('active');
    const prog = document.getElementById('qProgress');
    if (prog) prog.style.display = 'none';
    document.querySelectorAll('.quiz-prog').forEach(p => p.classList.remove('done'));
    document.querySelectorAll('.quiz-opt').forEach(o => o.classList.remove('selected'));
    document.querySelectorAll('.quiz-next').forEach(b => { if (b.id) b.disabled = true; });
    Object.keys(quizAnswers).forEach(k => delete quizAnswers[k]);
  };

  /* ── FAQ ACCORDION + TABS ── */
  window.krFaqToggle = function (btn) {
    const item = btn.closest('.faq-item');
    const ans = item.querySelector('.faq-a');
    const open = item.classList.contains('open');
    item.closest('.faq-group').querySelectorAll('.faq-item.open').forEach(function (o) {
      o.classList.remove('open');
      o.querySelector('.faq-a').style.maxHeight = null;
    });
    if (!open) {
      item.classList.add('open');
      ans.style.maxHeight = ans.scrollHeight + 'px';
    }
  };
  window.krFaqTab = function (btn, group) {
    document.querySelectorAll('.faq-tab').forEach(t => t.classList.remove('active'));
    btn.classList.add('active');
    document.querySelectorAll('.faq-group').forEach(function (g) {
      g.classList.remove('active');
      g.querySelectorAll('.faq-item.open').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.faq-a').style.maxHeight = null;
      });
    });
    const target = document.getElementById('faq-' + group);
    if (target) target.classList.add('active');
  };

  /* ── POPUP IMAGE SLIDESHOW ── */
  (function () {
    var slides = document.querySelectorAll('#popupSlideshow .popup-slide');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('active');
    }, 3000);
  })();
})();

// Remove hero highlight box
document.querySelectorAll('.hero-hl').forEach(function(el){
  el.style.cssText = 'background:none!important;background-image:none!important;padding:0!important;';
});

// PRODUCT SPOTLIGHT — fix blank image (img_url filter deprecated)
(function(){
  var imgWrap = document.querySelector('.skincare-img');
  if (!imgWrap) return;
  var img = imgWrap.querySelector('img');
  if (!img || img.naturalWidth > 0) return; // already loaded fine
  // Fetch product JSON to get featured image URL
  fetch('/products/glow-beef-tallow.js')
    .then(function(r){ return r.json(); })
    .then(function(p){
      var src = p.featured_image || (p.images && p.images[0]);
      if (src) {
        img.src = src;
        img.alt = p.title || 'Glow Beef Tallow';
      }
    })
    .catch(function(){
      // fallback to known CDN URL
      img.src = 'https://cdn.shopify.com/s/files/1/0587/6301/8445/files/BE718E10-66E9-4657-BED8-BC29B753886A.png?v=1744672537';
      img.alt = 'Glow Beef Tallow';
    });
  // Also set immediately via known URL in case fetch is slow
  img.src = 'https://cdn.shopify.com/s/files/1/0587/6301/8445/files/BE718E10-66E9-4657-BED8-BC29B753886A.png?v=1744672537';
})();
